import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { RouterService } from "../../../../shared/_services/router.service";
import { PageEvent } from "@angular/material/paginator";
import { ListTradingSymbolsResponse, TradingSymbolsService } from "./trading-symbols.service";
import { TradingSymbolView } from "../../../../shared/_types/trading-symbol.type";
import { CommandResult } from "../../../../shared/_types/command-result.type";
import { NotificationsService } from "../../../../shared/_services/notifications.service";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-trading-symbols",
    templateUrl: "./trading-symbols.component.html",
    styleUrl: "./trading-symbols.component.scss",
    standalone: false,
})
export class TradingSymbolsComponent implements OnInit, OnDestroy {
    private ngUnsubscribe = new Subject<any>();

    searchText: string = "";
    page: number = 0;
    pageSize: number = 10;
    totalTradingSymbols: number = 0;
    tradingSymbols: TradingSymbolView[] = [];
    isLoaded: boolean = false;

    displayedColumns: string[] = ["symbol", "company", "group", "exchange", "type", "isActive", "actions"];

    constructor(
        private router: RouterService,
        private tradingSymbolsService: TradingSymbolsService,
        private notificationsService: NotificationsService,
    ) {}

    ngOnInit(): void {
        this.pageChanged({ pageIndex: this.page, pageSize: this.pageSize } as PageEvent);
    }

    ngOnDestroy(): void {
        // prevent memory leak when component destroyed
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }

    pageChanged(e: PageEvent): void {
        this.tradingSymbolsService
            .list({
                page: e.pageIndex + 1,
                itemsPerPage: e.pageSize,
                searchText: this.searchText,
            })
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((response: ListTradingSymbolsResponse) => {
                this.tradingSymbols = response.symbols;
                this.totalTradingSymbols = response.total;
                this.page = e.pageIndex;
                this.isLoaded = true;
            });
    }

    search(): void {
        this.page = 0;
        this.pageChanged({ pageIndex: this.page, pageSize: this.pageSize } as PageEvent);
    }

    activate(symbol: TradingSymbolView): void {
        this.tradingSymbolsService
            .activate(symbol.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((res: CommandResult) => {
                if (!res.success) {
                    this.notificationsService.showError("Error", res.error);
                    return;
                }
                symbol.isActive = true;
            });
    }

    deactivate(symbol: TradingSymbolView): void {
        this.tradingSymbolsService
            .deactivate(symbol.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((res: CommandResult) => {
                if (!res.success) {
                    this.notificationsService.showError("Error", res.error);
                    return;
                }
                symbol.isActive = false;
            });
    }

    create(): void {
        this.router.navigate("/trading-symbols/new");
    }

    edit(symbol: TradingSymbolView): void {
        this.router.navigate(`/trading-symbols/${symbol.id}`);
    }

    delete(symbol: TradingSymbolView): void {
        this.tradingSymbolsService
            .delete(symbol.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((res: CommandResult) => {
                if (!res.success) {
                    this.notificationsService.showError("Error", res.error);
                    return;
                }
                this.search();
            });
    }
}
